// extracted by mini-css-extract-plugin
module.exports = {"hidden":"apply_hidden__iIiEO","textEmphasis":"apply_textEmphasis__3mwIY","wrapper":"apply_wrapper__TTf6M"};